import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Column } from 'hedron';
import { LogoImage } from './CreditCardLogo.css';

const mapStateToProps = ({ api: { s3BasePath } }) => {
  return { s3BasePath };
};

const CreditCardLogo = ({ isDesktop, s3BasePath, logoPath, margin, width }) => (
  <Column
    fluid
    xs={4.25}
    sm={2.5}
    md={isDesktop ? 4.25 : 2.5}
    lg={isDesktop ? 4.25 : 1.5}
    style={{ 'text-align': 'center' }}
  >
    <LogoImage src={`${s3BasePath}${logoPath}`} width={width} margin={margin} />
  </Column>
);

CreditCardLogo.propTypes = {
  isDesktop: PropTypes.bool.isRequired,
  logoPath: PropTypes.string.isRequired,
  margin: PropTypes.string,
  s3BasePath: PropTypes.string.isRequired,
  width: PropTypes.string,
};

export default connect(mapStateToProps)(CreditCardLogo);
